import * as types from "../dashboardActionTypes";

const initialState = {
    securityAlerts: {
        firstDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0  },
        secondDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 },
        thirdDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 },
        fourthDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 },
        fifthDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 },
        sixthDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 },
        seventhDay: { timeStamp: new Date(), lowSeverityCount: 0, mediumSeverityCount: 0, highSeverityCount: 0 }
    }
};

export default function securityAlertsLastWeekReducer(state = initialState.securityAlerts, action) {
    switch(action.type) {
        case types.LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS:
            return action.securityAlertsLastWeek;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/securityAlertsLastWeekReducer.js